import * as React from 'react';
//import Map from '../base/Map';
import styled from '../../theme/styled';
import oh from 'output-helpers';

//Style components
import { Row, Column } from '../base/Layout';
import { CardRow, Card } from '../base/Cards';
import { Text, Heading } from '../base/Text';
import { MainLogotypeContainer } from '../base/Logotype';
import { TeamMember, MemberList } from '../base/Team_Member';

import RightPanel from '../base/RightPanel';

//Images
import background from '../../images/senseview-front-pic.jpg';
//import mapbg from '../../images/svg-backgrounds/mapsectionbg.svg';
//import mapbg_mobile from '../../images/svg-backgrounds/mapsectionbg_mobile.svg';
import first_section_image from '../../images/section-images/senseview-1.png';
import second_section_image from '../../images/section-images/senseview-2.png';
import third_section_image from '../../images/section-images/senseview-3.png';
import northstar_section_image from '../../images/section-images/north-star.svg';
import allbinary_logo from '../../images/All-Binary-White.png';

import tomas from '../../images/team/Tomas-Sareklint.jpg';
import christian from '../../images/team/Christian-Malmström.jpg';
import joakim from '../../images/team/Joakim-Johansson.jpg';
import alexander from '../../images/team/Alexander-Ma.jpg';

interface MainViewProps {

}

interface SectionProps {
    background_color: string;
}

const MainViewContainer = styled.div`
    margin: 0;
    width: 100%;
`;

const Sections = {
	MainSection: styled.div`
        width: 100%;
        height: 75vh;
        background-color: ${props => props.theme.colors.dark[2]};
        background-image: url(${background});
		background-size: cover;
		background-position: center;
		position: relative;
		overflow: hidden;
		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.2);
		}
        .tagline {
            position: absolute;
            top: 50%;
            width: 100%;
			transform: translatey(-50%);
			z-index: 10;
        }
        .tagline h1 {
            font-size: 5em;
            margin: 0;
		}
		@media only screen and (max-width: 1200px) {
			.tagline {
				position: relative;
				top: 0;
				transform: none;
				padding: 8% 10%;
			}
			.tagline h1 {
				margin: 0;
				text-align: left;
				font-size: 4em;
			}
		}
    `,
    /*MapSection: styled.div`
        width: 100%;
        height: auto;
        background-color: ${props => props.theme.colors.background};
        position: relative;
        min-height: 40vh;
        @media only screen and (max-width: 1200px) {
            min-height: 70vh;
        }
    `,*/
    Section: styled.div<SectionProps>`
        width: 100%;
        background-color: ${props => props.background_color};
        padding: 10% 8%;
    `,
    ContactSection: styled.div`
        width: 100%;
        height: 200px;
        background-image: linear-gradient(to right top, #007cff, #008dff, #009cff, #00aaff, #00b7ff, #00c2f7, #00cae9, #00d1d8, #55d2b0, #8dcf89);
        position: relative;
        a {
            display: inline-block;
            transform: translate(-50%, -50%);
            position: absolute;
            top: 50%;
            left: 50%;
            background-color: transparent;
            color: white;
            border: 3px solid white;
            padding: 20px 40px;
            border-radius: 9999px;
			font-weight: bold;
			-webkit-transition: all 0.25s ease-out;
        	transition: all 0.25s ease-out
		}
		a:hover {
			padding: 20px 60px;
			background-color: white;
			color: ${props => props.theme.colors.dark[1]}
		}
    `,
    Footer: styled.div`
        width: 100%;
        padding: 5% 8%;
		background-color: ${props => props.theme.colors.dark[1]}
		color: white;
		h2 {
			font-size: 20px;
			text-transform: uppercase;
			font-weight: bold;
		}
		ul {
			color: white;
			margin-top: 30px;
		}
		ul li {
			font-size: 16px;
			margin: 10px 0;
		}
		.footer-right {
			display: flex;
			justify-content: flex-end;
			align-items: flex-end;
			min-height: 100%;
			padding: 0 0 10px 0;
		}
		.footer-right p {
			font-size: 16px;
			margin-right: 1em;
		}
		.footer-right .allbinary-logo {
			max-height:100%;
			max-width: 50px;
			vertical-align: middle;
		}
		.footer-divider {
			margin: 30px 0;
			height: 5px;
			border-radius: 9999px;
			background-color: white;
		}
		.footer-copyright {
			text-align: right;
			font-size: 16px;
		}
		@media only screen and (max-width: 1200px) {
			text-align: center;
			h2 {
				font-size: 24px;
			}
			ul li {
				font-size: 20px;
				margin: 20px 0;
			}
			.footer-right {
				padding: 50px 0 10px 0;
				justify-content: center;
			}

		}
    `,
};

const Divider = styled.div`
    width: 100%;
    height: 10px;
    background-color: #364161;
`;

/*const MapContainer = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
`;*/

/*const MapColumn = styled.div`
    position: relative;
    width: 40%;
    min-height: 40vh;
    color: white;
    background: url(${mapbg});
    .center-vertical {
        position: absolute;
        top: 50%;
        transform: translatey(-50%);
    }
    @media only screen and (max-width: 1200px) {
        width: 100%;
        min-height: 0;
        height: auto;
        background: ${props => props.theme.colors.brand[3]};
        .center-vertical {
            position: relative;
            top: 0;
            transform: none;
            padding: 60px 0;
        }
        p {
            text-align: center;
        }
    }
`;*/

interface ImageContainerProps {
    width: string;
    width_on_mobile: string;
    margin_on_mobile: string;
}

const ImageContainer = styled.div<ImageContainerProps>`
    position: relative;
    min-height: 100%;
    display: flex;
    align-items: center;
    img {
        display: block;
        width: ${props => props.width};
        margin: auto;
	}
	@media only screen and (max-width: 1200px) {
		img {
			position: relative;
			transform: none;
			top: 0;
			left: 0;
            width: ${props => props.width_on_mobile};
            margin: ${props => props.margin_on_mobile};
		}
	}
`;

const AdditionalInformation = styled.div`
    text-align: center;
    padding: 30px 0;
`;

class MainView extends React.Component {

    constructor(props: MainViewProps) {
        super(props);
    }


    render() {

        //RIGHT PANEL RENDER FALSE FOR NOT RENDERING
        let render_right_panel = false;

        return (
            <MainViewContainer>
                <Sections.MainSection>
                    <Row justify_content="space-between">
                        <Column width="40" padding_on_mobile={false}><MainLogotypeContainer></MainLogotypeContainer></Column>
                        <Column width="55">
                            <Heading className="tagline" light={true}>From sensors to insights</Heading>
                        </Column>
                    </Row>
                </Sections.MainSection>
                <Divider/>
                <Sections.Section background_color="white">
                    <Row justify_content="space-around">
                        <Column width="40">
                            <ImageContainer width="100%" width_on_mobile="80%" margin_on_mobile="0 auto"><img src={first_section_image}/></ImageContainer>
                        </Column>
                        <Column width="40">
                            <Heading>{oh.translate("what_is_heading")}<div className="underscore"></div></Heading>
                            <Text>SenseView är en experimentplattform speciellt framtagen för Sveriges sensornätsägare och smarta städer. Syftet är att underlätta meningsfulla piloter med uppkopplade sensorer för att snabbt få svar på värdet och få med fler på tåget. SenseView tar vid där sensordata trillar ur nätverksservern och gör det möjligt att dra meningsfulla insatser från din data.<br/><br/>
                            I utvecklingen av SenseView har vi lagt stor tonvikt på användargränssnittet för att hjälpa dig som användare lyfta fram de projekt du genomför såväl internt som mot dina kunder.</Text>
                        </Column>
                    </Row>
                </Sections.Section>
                <Sections.Section background_color="#EEEEEE">
                    <Row justify_content="space-around" reverse={true}>
                        <Column width="40">
                            <Heading>{oh.translate("how_heading")}<div className="underscore"></div></Heading>
                            <Text>SenseView erbjuds som molnbaserad tjänst med en transparent prismodell för att du ska ha koll på dina kostnader. Vi tror inte på inlåsning i varken bindningstid eller specifika vertikaler innan du vet att ett projekt är värt att bygga i stor skala. SenseView är en horisontell plattform för hantering och visualisering av alla typer av sensordata. Dessutom är det möjligt att mixa in data som kommer från andra källor än sensorer, tex väderdata.<br/><br/>
                            Vi har valt att nyttja fördelarna med Google Cloud som underliggande plattform. Som kund kan du prova SenseView kostnadsfritt under första månaden med dina specifika pilotprojekt. Efter det binder du dig aldrig mer än ett kvartal åt gången.</Text>
                        </Column>
                        <Column width="40">
                            <ImageContainer width="100%" width_on_mobile="80%" margin_on_mobile="0 auto"><img src={second_section_image}/></ImageContainer>
                        </Column>
                    </Row>
					{/*<Spacer height="50" display_on_desktop={false}/>*/}
                </Sections.Section>
                {/** DISABLED MAP UNTIL API FIXED
                <Sections.MapSection>
                    <MapContainer>
                        <Map></Map>
                    </MapContainer>
                    <MapColumn>
                        <Row className="center-vertical" justify_content="center">
                            <Column width="70">
                                <Heading light={true}>{oh.translate("try_heading")}!<div className="underscore"></div></Heading>
                                <Text light={true}>Testa gärna våra sensorer på kartan.</Text>
                            </Column>
                        </Row>
                    </MapColumn>
                </Sections.MapSection>*/}
                <Sections.Section background_color="#E0E0E0">
					{/*<Spacer height="50" display_on_desktop={false}/>*/}
                    <Row justify_content="space-around">
                        <Column width="40">
							<ImageContainer width="90%" width_on_mobile="80%" margin_on_mobile="0 auto"><img src={third_section_image}/></ImageContainer>
                        </Column>
                        <Column width="40">
                            <Heading>{oh.translate("background_heading")}<div className="underscore"></div></Heading>
                            <Text>De senaste åren har allt fler energibolag och städer i Sverige byggt sensornät baserade på LoRaWAN. Efter att ha jobbat med flera av dessa bolag och smarta städer insåg vi att det är avgörande att parallellt med nätutbyggnad genomföra pilotprojekt för att så snart som möjligt kunna få nytta av gjorda investeringar. Det är först när man tagit något från sensor till insikt och processförändring i liten skala det går att dra slutsatser om hur ett IOT-projekt skulle kunna lösa problem, spara kostnader eller förbättra service om det skalas upp.<br/><br/>
                            Baserat på lärdomar och ett antal intervjuer med ledande personer inom branschen identifierade vi en stor bromskloss. Det är idag svårt att sjösätta värdefulla piloter med tydligt syfte och tidsram utan att investera i stora, dyra system och mängder av sensorer. Bristen på strukturerade piloter gjorde det svårt att få med intern personal och kunder på tåget.<br/><br/>
                            Vi tror på styrkan att i liten skala genomföra tidssatta experiment med tydliga kriterier för vad som krävs för att kunna ta beslut på om projektet är värt att göra i stor skala.</Text>
                        </Column>
                    </Row>
                </Sections.Section>
                <Sections.Section background_color="white">
                    <Row justify_content="space-around" reverse={true}>
                        <Column width="60">
                            <Heading>{oh.translate("our_call_heading")}<div className="underscore"></div></Heading>
                            <Text>Vi är övertygade om att slutresultatet av en IOT-investering är direkt kopplat till antalet experiment och piloter man genomför. Detta tankesätt delar vi med några av de mest framgångsrika digitala bolagen i världen. Varje experiment bör ha som mål att svara på frågan om man bör lägga ner eller skala upp. Att lägga ner piloter som inte ger tillräckligt värde är en lika stor framgång som att hitta projekt att skala. Att tidigt identifiera vad som inte fungerar, innan man lagt för mycket tid och pengar, är en stor konkurrensfördel i dagens snabbrörliga värld.<br/><br/>
                            Vi vill uppmuntra dig att köra flera parallella piloter med uppkopplade sensorer för maximalt lärande. Därför har vi medvetet valt att inte koppla prismodellen till antalet olika piloter och experiment. Vår drivkraft är att du som kund ska få snabbare resultat av din investering i ett sensornät, och vårt sätt att mäta framgång med SenseView är därför hur många experiment/piloter som körs i plattformen.</Text>
                        </Column>
                        <Column width="30"><ImageContainer width="100%" width_on_mobile="20%" margin_on_mobile="0 auto"><img src={northstar_section_image}/></ImageContainer></Column>
                    </Row>
                </Sections.Section>
                <Sections.Section background_color="#EEEEEE">
                    <Heading light={false} text_align="center">{oh.translate("price_heading")}<div className="underscore"></div></Heading>
                    <Row justify_content="center">
                        <Column width="100">
                        <CardRow>
                                <Card title="Starter" price="4.900 kr" price_fine_print="+1200 kr/månad drift/support" features={
                                    ["1-100 " + oh.translate("sensors", false),
                                    "3 " + oh.translate("user_accounts"),
                                    oh.translate("up_to") + " 5000 " + oh.translate("map_requests", false) + " / " + oh.translate("month", false),
                                    oh.translate("brand"),
                                    oh.translate("alarm_feature"),
                                    "API " + oh.translate("further_integration", false),
                                    oh.translate("secure_cloudstorage") + " EU",
                                    oh.translate("data_export"),
                                    oh.translate("personal_contact_pilot"),
                                    oh.translate("maintenance_development")
                                    ]}/>
                                <Card main={true} title="Scaler" price="10.900 kr" price_fine_print="+1800 kr/månad drift/support" features={
                                    ["101-1000 " + oh.translate("sensors"),
                                    "10 " + oh.translate("user_accounts"),
                                    oh.translate("unlimited") + " " + oh.translate("map_requests", false) + " / " + oh.translate("month", false),
                                    oh.translate("brand"),
                                    oh.translate("alarm_feature"),
                                    "API " + oh.translate("further_integration", false),
                                    oh.translate("secure_cloudstorage") + " EU",
                                    oh.translate("data_export"),
                                    oh.translate("personal_contact_pilot"),
                                    oh.translate("maintenance_development")
                                    ]}/>
                        </CardRow>
                        <AdditionalInformation>{oh.translate("pricing_information")}</AdditionalInformation>
                        </Column>
                    </Row>
                </Sections.Section>
                <Sections.Section background_color="#E0E0E0">
                    <Heading light={false} text_align="center">{oh.translate("team_heading")}<div className="underscore"></div></Heading>
                    <Row justify_content="center">
                        <Column width="90">
                            <MemberList>
                                <TeamMember
                                    image_url={tomas}
                                    name="Tomas Sareklint"
                                    position="Kreativ ingenjör"
                                    email="tomas.sareklint@allbinary.se"
                                />
                                <TeamMember
                                    image_url={christian}
                                    name="Christian Malmström"
                                    position="Sälj, marknad &amp; partnerskap"
                                    email="christian.malmstrom@allbinary.se"
                                />
                                <TeamMember
                                    image_url={joakim}
                                    name="Joakim Johansson"
                                    position="Programvaruutvecklare"
                                    email="joakim.johansson@allbinary.se"
                                />
                                <TeamMember
                                    image_url={alexander}
                                    name="Alexander Ma"
                                    position="UI &amp; UX"
                                    email="alexander.ma@allbinary.se"
                                />
                                <TeamMember
                                    name="Mikael Richardsson"
                                    position="Junior programvaruutvecklare"
                                    email="mikael.richardsson@allbinary.se"
                                />
                                <TeamMember
                                    name="Mathias Djärv"
                                    position="Senior programvaruutvecklare"
                                    email="mathias.djarv@allbinary.se"
                                />
                            </MemberList>
                        </Column>
                    </Row>
                </Sections.Section>
                <Sections.ContactSection>
                    <a href={"mailto:christian.malmstrom@allbinary.se?subject=" + oh.translate("email_subject")}>{oh.translate("contact_us")}</a>
                </Sections.ContactSection>
                <Sections.Footer>
                    <Row justify_content="space-between">
                        <Column width="25">
							<h2>{oh.translate("contact_us")}</h2>
							<ul>
								<li>+46 733 12 49 40</li>
								<li><a href={"mailto:christian.malmstrom@allbinary.se?subject=" + oh.translate("email_subject")}>christian.malmstrom@allbinary.se</a></li>
							</ul>
                        </Column>
						<Column width="25">
							<div className="footer-right">
								<p>Senseview drivs och utvecklas av:</p>
								<img className="allbinary-logo" src={allbinary_logo}></img>
							</div>
						</Column>
                    </Row>
					<div className="footer-divider"/>
					<Row>
						<Column width="100">
							<p className="footer-copyright">&copy; All Binary</p>
						</Column>
					</Row>
                </Sections.Footer>
                {render_right_panel && <RightPanel />}
            </MainViewContainer>
        );
    }
}

export default MainView;



// WEBPACK FOOTER //
// ./src/components/views/MainView.tsx